import { DiagnosticsLogState } from './schema/DiagnosticsLogState';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';

let initialDiagnosticsLogState: DiagnosticsLogState = {
    loggers: new ObservableMap<string, DiagnosticsLogState>({}) as any,
    selectedPivotKey: '',
    sessionDetails: '',
};

export const getDiagnosticsLogState = createStore<DiagnosticsLogState>(
    'diagnosticsLogState',
    initialDiagnosticsLogState
);

export var logStore = getDiagnosticsLogState();
